import { addRejectionContext } from '@/utils/sentry/addRejectionContext'
import { StrictMode, startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import * as Sentry from '@sentry/react-router'

const productionHost = 'app.vaults.fyi'
const sentryTracing = Sentry.reactRouterTracingIntegration()
const sentryClientInstrumentation = Sentry.createSentryClientInstrumentation()

Sentry.init({
  dsn: 'https://cd6d45c70367174aa0a722d876ae3999@o4505872996827136.ingest.us.sentry.io/4508319572099072',
  integrations: [sentryTracing, Sentry.replayIntegration({ maskAllText: true, maskAllInputs: true, blockAllMedia: true })],
  beforeSend: addRejectionContext,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [new RegExp(`^https://${productionHost.replaceAll('.', '\\.')}`)],
  environment: window.location.hostname === productionHost ? 'production' : 'development',
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.1,
  enabled: process.env.NODE_ENV === 'production',
})

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter instrumentations={[sentryClientInstrumentation]} onError={Sentry.sentryOnError} />
    </StrictMode>
  )
})
